module.exports = __webpack_public_path__ + "img/swiper1.c4d612c9.png";